// Module
var code = "<div class=\"row\"> <div class=\"col-12 text-center mb-2\"> <button type=\"button\" class=\"btn btn-primary\" id=\"validation-button\">Accéder à ma sélection</button> </div> </div> ";
// Exports
module.exports = code;